// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 2H1V19H12.5V6.5H23V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12.5 20H5V22H12.5V20Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14.5 8.5H24V22H14.5V8.5ZM18.248 16.998V19.002H20.252V16.998H18.248Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-device-filled')
export default class DeviceFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'device-filled',
    }
  }
}
